import {
  Copy,
  Heading,
  Image,
  Link,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import {
  statesContent,
  supportEmail,
} from 'src/components/selfService/features/Signup/steps/ValidationStep/constants';

export function InReviewState(): JSX.Element {
  const { inReview } = statesContent;

  const { isPhone } = useScreenSizes();
  const textAlign = isPhone ? 'left' : 'center';

  return (
    <>
      <Stack y="sm" alignSelf="center">
        <Image
          width="250px"
          src={inReview.illustrationUrl}
          alt=""
          role="presentation"
        />
      </Stack>
      <Stack y="sm">
        <Heading variant="h1" textAlign={textAlign}>
          {inReview.title}
        </Heading>
      </Stack>
      <Stack y="sm">
        <Copy variant="body" textAlign={textAlign} display="inline-block">
          {inReview.text[0]}
        </Copy>
      </Stack>
      <Stack y="md">
        <Copy variant="body" textAlign={textAlign} display="inline-block">
          {inReview.text[1]}{' '}
          <Link variant="muted" href={`mailto:${supportEmail}`}>
            {supportEmail}
          </Link>
        </Copy>
      </Stack>
    </>
  );
}
